"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
const boxClasses = (0, _generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var _default = exports.default = boxClasses;
